<template>
     <q-modal v-model="show_change_password" @hide="hideModal()" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="hideModal()" icon="fas fa-times" v-if="!user_change_password" />
                <q-toolbar-title>
                    {{ $t('change_password') }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row">
                    <div class="col-12">
                        <q-input v-model="current_password" :float-label="$t('current_password')" type="password" :error="$v.current_password.$error" @input="$v.current_password.$touch" />
                    </div>

                    <div class="col-12">
                        <q-field :helper="$t(getPasswordHelper)" :error="$v.new_password.$error">
                            <q-input v-model="new_password" :float-label="$t('password')" type="password" :error="$v.new_password.$error" @input="$v.new_password.$touch" />
                        </q-field>
                    </div>

                    <div class="col-12">
                        <q-input v-model="confirm_password" :float-label="$t('confirm_password')" type="password" @keyup.enter.native="setNewPassword()" :error="$v.confirm_password.$error" @input="$v.confirm_password.$touch" />
                    </div>

                    <div class="col-12">
                        <q-btn color="primary" class="full-width q-mt-md" icon="fal fa-key" :label="$t('set_new_password')" @click="setNewPassword()" />
                    </div>

                    <div class="col-12">
                        <q-btn color="tertiary" class="full-width q-mt-md" icon="fal fa-times" :label="$t('cancel')" @click="hideModal()" v-if="!user_change_password" />
                    </div>
                </div>
            </div>
        </q-modal-layout>

        <q-dialog v-model="success" @ok="hideModal()">
            <span slot="title">{{ $t('change_password') }}</span>

            <span slot="message">{{ $t('new_password_set_success') }}</span>
        </q-dialog>

        <q-dialog v-model="error">
            <span slot="title">{{ $t('error') }}</span>

            <span slot="message">{{ $t('current_password_is_incorrect') }}</span>
        </q-dialog>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "authenticated"] },

    props: ['show_change_password'],

    data() {
        return {
            current_password: '',
            new_password: '',
            confirm_password: '',
            error: false,
            success: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            password_strong_level: 'params/password_strong_level',
            user_change_password: 'common/user_change_password'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPasswordHelper(){
            if (this.password_strong_level == 'strong') {
                return 'helper_password_strong'
            }
            else if (this.password_strong_level == 'medium') {
                return 'helper_password_medium'
            }
            else {
                return 'helper_password_low'
            }
        }
    },

    methods: {
        hideModal() {
            this.success = false
            this.error = false
            this.$v.$reset()
            this.$emit('hide_modal', '')
        },

        validPassword(){
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})");
            var mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");
            var low = new RegExp ("^(?=.{6,})")

            if (this.password_strong_level == 'strong') {
                return strongRegex.test(this.new_password)
            }
            else if (this.password_strong_level == 'medium') {
                return mediumRegex.test(this.new_password)
            }
            else {
                return low.test(this.new_password)
            }
        },

        setNewPassword() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('current_password', this.current_password)
                fd.append('new_password', this.new_password)
                fd.append('confirm_password', this.confirm_password)

                this.$axios.post(`/etraining_profile/my_profile/change_user_password/`, fd, this.getHeader)
                .then(response => {
                    this.success = true
                    this.$store.dispatch('common/SET_USER_CHANGE_PASSWORD', [false])
                })
                .catch(e => {
                    this.error = true
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
        }
    },

    validations() {
        return {
            current_password: { required },
            new_password: { required,
                validPassword() {
                    return this.validPassword()
                }
            },
            confirm_password: { sameAsPassword: sameAs('new_password') },
        }
    }
}
</script>

<style>

</style>
